import * as adventure from './adventure'
import * as end from './end'
import * as husbandry from './husbandry'
import * as nether from './nether'
import * as story from './story'

export const advancements = {
  adventure,
  end,
  husbandry,
  nether,
  story,
}

export default advancements
